/**
 * Focus on the input element of the given element.
 *
 * @param el The element to focus on.
 * @param autoFocus Whether to auto focus on the input element.
 */
export function focusElementInput(el: HTMLElement, autoFocus?: boolean) {
  if (autoFocus === false) {
    return
  }

  const inputEl = el.tagName === 'INPUT' ? el : el.querySelector('input')

  inputEl?.focus()
}

/**
 * Focus on the textarea element of the given element.
 *
 * @param el The element to focus on.
 * @param autoFocus Whether to auto focus on the textarea element.
 */
export function focusElementTextarea(el: HTMLElement, autoFocus?: boolean) {
  if (autoFocus === false) {
    return
  }

  const textareaEl = el.tagName === 'TEXTAREA' ? el : el.querySelector('textarea')

  textareaEl?.focus()
}
